import { createApi } from '../createApi';
import * as dummy from '../dummy/vehicles';
import * as real from '../api/vehicles';

const api = createApi(dummy, real);

/** 차량 관리 서비스 — API_DOCS: 22. 관리자 - 차량 */
export const vehicleService = {
  getList: api.getVehicles,
  getById: api.getVehicleById,
  create: api.createVehicle,
  update: api.updateVehicle,
  delete: api.deleteVehicle,
};
